import React from 'react';
import { IconSizes, XCloseIcon } from '@newcore/icons';
import { TextSizes } from '@newcore/ui/enums/typography-text-sizes';
import { Text } from '@newcore/ui/typography';
import { StatusContainer } from '@/components/ui/status-container';
import { useLanguage } from '@/contexts/language-context';
import { StatusVariant } from '@/enums/status-variant';

export const PushNotificationPollingDeclinedState: React.FC = () => {
  const { t } = useLanguage();

  return (
    <StatusContainer
      variant={StatusVariant.ERROR}
      title={t('mfa.declined')}
      message={t('mfa.declinedMessage')}
      icon={<XCloseIcon size={IconSizes.LG} strokeWidth={2.5} />}
    >
      <Text as='p' size={TextSizes.MD} className='text-center text-secondary'>
        {t('mfa.canCloseWindow')}
      </Text>
    </StatusContainer>
  );
};
